var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"currentColor","strokeMiterlimit":"10","strokeWidth":"2.5"},[React.createElement("path",{"d":"M1.54 7.36a8.25 8.25 0 1 1 .82 6.25 8.13 8.13 0 0 1-.82-6.25Z","key":0}),React.createElement("path",{"strokeLinecap":"round","d":"m13.73 16.74 4.36 7.35","key":1})]));
}

Search.defaultProps = {"width":"19.34","height":"25.34","data-name":"Layer 1","viewBox":"0 0 19.34 25.34"};

module.exports = Search;

Search.default = Search;
